// extracted by mini-css-extract-plugin
export default {"badge":"Badges-module__badge___2JtHT","badgeText":"Badges-module__badgeText___WnZkF"};